<template>
  <div class="heading">
     <Popover v-if="remove_popup" service_type="" :popup_type="popup_type" :serv_index ="fake_serv_index"  @closePopUp="remove_popup_card()" @removeService="action_status"/>
    <h4 class="px-3">
      <span class="pink">{{title}}</span>
      <a @click="goBack" ><img class="pull-right point_cursor mt-12" src="../assets/images/icons/close_icon.svg"></a>
    </h4>
  </div>
</template>

<style scoped>
.heading{
  position: fixed;
  top: 0;
  background:#ffffff;
  height: 50px;
  text-align: center;
  width: 100%;
  z-index: 50;
  border-bottom: 2px solid #EBEFF2;
}

.heading h4{
  line-height: 50px;
}
</style>

<script>
import Popover from '@/components/popover_component.vue';
export default {
  name: 'heading',
  props: {
    title: String
  },
  components:{Popover},
  data(){
    return{
      popup_type:'Discard_Changes',
      fake_serv_index:1,
      remove_popup:false
    }
  },
  methods:{
    goBack(){
        if(this.title == 'New Booking' || this.title == 'Edit Booking' || this.title == 'Booking Reschedule'){
          this.$session.remove('booking_customer_id');
          this.$store.state.selected_products = [];
        }
        switch(this.title) {
          case 'View Booking':
            this.$router.push('/calendar')
            break;
          case 'Checkout':
            this.$router.push('/viewbooking')  
            break;
          case 'New Product':
            if(this.$session.has("changes_happened"))this.remove_popup = true;
            else this.$router.go(-1);
            break;
          case 'Edit Product':
            if(this.$session.has("changes_happened")) this.remove_popup = true;
            else this.$router.go(-1);
            break;
          default:
            this.$router.go(-1);
        }   
    },
    remove_popup_card(){
      this.remove_popup = false;
    },
    action_status(){
      this.$router.go(-1);
    }
  }
}
</script>